

























import Vue from "vue";
import { SharedState } from "@/common/state";
import { AppAnalytics } from "@/analytics";
import { computed } from "@vue/composition-api";
import PlansModal from "@/components/modals/plans-modal/PlansModal.vue";
import moment from "moment";
import { UseModal } from "../modal";
import { startTrial } from "@/common/api/api";
import { delayBy } from "@/fp";
/* 
## AFTER trial, upgraded to standard
id: "standard"
isTrial: false
isTrialExhausted: true

## UPGRADED without trial
id: "standard"
isTrial:false
isTrialExhausted: false
*/

export default Vue.extend({
  setup() {
    const is_logged = computed(() => SharedState.isUserLogged.value);

    const edition_name = computed(
      () => SharedState.loggedUser.value.paymentEdition.name
    );

    const trial = computed(() => SharedState.loggedUser.value.trial);

    /* 
    ## BEFORE trial
    id: "launch"
    isTrial:false
    isTrialExhausted: false
    */

    const is_before_trial = computed(
      () =>
        edition_name.value === "launch" &&
        !trial.value.active &&
        !trial.value.exhausted
    );
    /* 
     ## DURING trial
     id: "standard"
     isTrial: true
     isTrialExhausted: true
     */
    const is_during_trial = computed(
      () => edition_name.value === "standard" && trial.value.active
    );

    /* 
    ## AFTER trial, not upgraded
    id: "launch"
    isTrial: false
    isTrialExhausted: true
    */

    const is_after_trial_and_not_upgraded = computed(
      () =>
        edition_name.value === "launch" &&
        !trial.value.active &&
        trial.value.exhausted
    );

    const show_strip = computed(
      () =>
        is_logged.value &&
        (is_before_trial.value ||
          is_during_trial.value ||
          is_after_trial_and_not_upgraded.value)
    );

    const sentence = computed(() => {
      switch (true) {
        case is_before_trial.value:
          return `Start your free 14-day trial of Standard`;
        case is_during_trial.value:
          return `you have ${daysLeft.value} ${
            daysLeft.value !== 1 ? "days" : "day"
          } left until
      <span class="font-bold">Standard trial</span> is over. please contact
      <a href="mailto:sales@cognni.ai" class="text-primary lowercase text-xl"
        >sales@cognni.ai</a
      >
      for more information.`;
        case is_after_trial_and_not_upgraded.value:
          return `Your free trial is over. please contact
      <a href="mailto:sales@cognni.ai" class="text-primary lowercase text-xl"
        >sales@cognni.ai</a
      >
      for more information.`;
        default:
          return "?";
      }
    });

    const is_in_upgrade_status = computed(
      () => is_during_trial.value || is_after_trial_and_not_upgraded.value
    );

    const action_name = computed(() => {
      switch (true) {
        case is_before_trial.value:
          return "Start Trial";
        case is_in_upgrade_status.value:
        default:
          return "Upgrade";
      }
    });

    const today = moment(new Date());
    const daysLeft = computed(() => {
      const end_day = moment(
        SharedState.loggedUser.value.trial.endsAt || new Date()
      );
      return Math.abs(today.diff(end_day, "days")) + 1;
    });

    const submit = () => {
      if (is_during_trial.value || is_after_trial_and_not_upgraded.value) {
        upgrade();
      } else {
        start_trial();
      }
    };
    const upgrade = () => {
      AppAnalytics.report({
        component: "Upgrade",
        eventName: "Change_plan[Area:Logo, Action:Open]",
      });
      UseModal().show(PlansModal);
    };

    const start_trial = async () => {
      AppAnalytics.report({
        component: "Upgrade",
        eventName: "start_standard_trial_clicked",
      });
      await startTrial();
      // @ts-ignore
      window.show_confetti();
      await delayBy(2000);
      const url = location.href + "?firsttime=true";
      window.open(url, "_self");
    };

    return {
      show_strip,
      sentence,
      daysLeft,
      submit,
      is_logged,
      edition_name,
      is_before_trial,
      is_during_trial,
      is_after_trial_and_not_upgraded,
      is_in_upgrade_status,
      action_name,
    };
  },
});
